module.exports = __webpack_public_path__ + "img/pc_left.18797f9.webp";